// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop-module__backdrop___1wVuN","visible":"Backdrop-module__visible___2IP1P","spinner":"Backdrop-module__spinner___yBtqA"};